import { Show } from '@/components/show'
import { useEffect, useRef } from 'react'
import { Loader } from '@/components/loader'

import '@/components/webComponents/OpenModal'
import { Button } from '@/components/ui/button'

export interface NextSubmitButtonsProps {
  hasSubmit: boolean
  isPartialSaveLoading: boolean
  onNext?: () => void
  submitButtonLabel: string
  submitState: 'error' | 'success' | 'loading' | 'ready'
  validate: () => string | undefined
}

export function NextSubmitButtons({
  hasSubmit,
  isPartialSaveLoading,
  onNext,
  submitButtonLabel,
  submitState,
  validate
}: NextSubmitButtonsProps) {
  const openModalRef = useRef<HTMLElement>(null)

  useEffect(() => {
    // Set attributes directly on the web component using the ref
    if (openModalRef.current) {
      openModalRef.current.style.visibility = 'hidden'
    }
  }, [])

  function triggerModal() {
    const validation = validate()
    if (validation) return
    if (openModalRef.current) {
      openModalRef.current.click()
    }
  }

  return (
    <div className='flex w-full justify-end gap-1'>
      <Show when={onNext}>
        <Show
          when={!isPartialSaveLoading}
          fallback={<Loader message='Loading' />}
        >
          <Button size='lg' onClick={onNext}>
            Next
          </Button>
        </Show>
      </Show>

      <open-modal ref={openModalRef} linkId='submit-modal' />

      <Show when={hasSubmit}>
        <Show
          when={submitState !== 'success'}
          fallback={<Button size='lg'>Success</Button>}
        >
          <Button
            size='lg'
            disabled={submitState === 'loading'}
            onClick={triggerModal}
          >
            {submitButtonLabel}
          </Button>
        </Show>
      </Show>
    </div>
  )
}
